import { render, staticRenderFns } from "./InfoMyStudio.vue?vue&type=template&id=132a55cc&scoped=true"
import script from "./InfoMyStudio.vue?vue&type=script&lang=js"
export * from "./InfoMyStudio.vue?vue&type=script&lang=js"
import style0 from "./InfoMyStudio.vue?vue&type=style&index=0&id=132a55cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a55cc",
  null
  
)

export default component.exports